import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { TbSettingsCancel } from "react-icons/tb";
import { toast, Toaster } from 'react-hot-toast';
import { X } from 'lucide-react';
import axios from 'axios';
const Sidebar = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [isExpanded, setIsExpanded] = useState(true);
    const [emailChangeOpen, setEmailChangeOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    // fields from API
    const [companyName, setCompanyName] = useState("");
    const [fromEmail, setFromEmail] = useState("");
    const [contactName, setContactName] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const toggleSidebar = () => {
        setIsExpanded((prev) => !prev);
    };

    const logo = sessionStorage.getItem('CompanyLogo');

    const fetchSettings = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getcompanysettings';
        const url = `${baseURl}${apiPath}`;

        setLoading(true);
        try {
            const res = await axios.post(
                url,
                { company_id: 1 },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = res?.data?.Result_value?.[0];

            setCompanyName(data?.name || "");
            setFromEmail(data?.from_email || "");
            setContactName(data?.contact_person_name || "");
            setContactEmail(data?.contact_person_email || "");

        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    // open modal + fetch data
    const openModal = () => {
        fetchSettings();
        setEmailChangeOpen(true);
    };

    const handleUpdate = async () => {
        setLoading(true);
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/updatecompanysettings';
        const url = `${baseURl}${apiPath}`;
        const payload = {
            company_id: 1,
            company_name: companyName,
            from_email: fromEmail,
            contact_person_name: contactName,
            contact_person_email: contactEmail
        };

        try {
            const res = await axios.post(
                url,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            toast.success('Contact person details updated successfully');

            setTimeout(() => {
                setEmailChangeOpen(false);
            }, 1000);

        } catch (error) {
            console.error(error);
            alert("Update failed!");
        }
        setLoading(false);
    };


    return (
        <>
            <div className={` flex flex-col h-screen bg-black transition-all  ${isExpanded ? 'md:w-64' : 'w-24'}`}>
                <div className='m-4 my-6 text-center flex flex-col md:flex-row justify-around items-center '>
                    <img src="https://www.domaincabinets.com/v/vspfiles/templates/260/images/template/header_bg.png" alt="" />

                </div>

                {isExpanded ? ('') : (
                    <div className='mx-3 border-b border-[#8F9BC3]'></div>
                )}



                <nav className="flex-1 mt-3">

                    <ul>

                        <li className={` ${isExpanded ? 'ml-5 mt-5' : 'flex justify-center mt-8'}`}>
                            <NavLink
                                to='/admin/layouts'
                                className={({ isActive }) =>
                                    `flex items-center ${isActive ? 'text-blue-400' : 'text-[#8F9BC3]'}`
                                }
                            >
                                {isExpanded && <span className='ml-3.5 text-sm md:text-lg font-semibold hidden md:block'>Layouts</span>}
                            </NavLink>
                        </li>
                        <li className={` ${isExpanded ? 'ml-5 mt-5' : 'flex justify-center mt-8'}`}>
                            <NavLink
                                to='/admin/colors'
                                className={({ isActive }) =>
                                    `flex items-center ${isActive ? 'text-blue-400' : 'text-[#8F9BC3]'}`
                                }
                            >
                                {isExpanded && <span className='ml-3 text-sm md:text-lg font-semibold hidden md:block'>Colors</span>}
                            </NavLink>
                        </li>
                        <li className={` ${isExpanded ? 'ml-5 mt-5' : 'flex justify-center mt-8'}`}>
                            <NavLink
                                to='/admin/collections'
                                className={({ isActive }) =>
                                    `flex items-center ${isActive ? 'text-blue-400' : 'text-[#8F9BC3]'}`
                                }
                            >
                                {isExpanded && <span className='ml-3 text-sm md:text-lg font-semibold hidden md:block'>Collections</span>}
                            </NavLink>
                        </li>
                        <li className={` ${isExpanded ? 'ml-5 mt-5' : 'flex justify-center mt-8'}`}>
                            <NavLink
                                to='/admin/groups'
                                className={({ isActive }) =>
                                    `flex items-center ${isActive ? 'text-blue-400' : 'text-[#8F9BC3]'}`
                                }
                            >
                                {isExpanded && <span className='ml-3 text-sm md:text-lg font-semibold hidden md:block'>Groups</span>}
                            </NavLink>
                        </li>
                        <li className={` ${isExpanded ? 'ml-5 mt-5' : 'flex justify-center mt-8'}`}>
                            <NavLink
                                to='/admin/distributor'
                                className={({ isActive }) =>
                                    `flex items-center ${isActive ? 'text-blue-400' : 'text-[#8F9BC3]'}`
                                }
                            >
                                {isExpanded && <span className='ml-3 text-sm md:text-lg font-semibold hidden md:block'>Distributor</span>}
                            </NavLink>
                        </li>

                        <li
                            onClick={openModal}
                            className={`absolute bottom-14 pl-4 cursor-pointer ${isExpanded ? 'ml-5 mt-5' : 'flex justify-center mt-8'}`}
                        >
                            <TbSettingsCancel size={40} className="text-[#8F9BC3] hover:text-white duration-200" />
                        </li>

                        <li className={`absolute bottom-4 ${isExpanded ? 'ml-5 mt-5' : 'flex justify-center mt-8'}`}>
                            <Link to='/' className='flex items-center'>
                                {isExpanded && <span className='ml-4 text-sm md:text-lg font-semibold text-[#8F9BC3] hidden md:block'>Logout</span>}
                            </Link>
                        </li>
                    </ul>

                </nav>
            </div>
            {emailChangeOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
                    <div className="bg-white w-full max-w-md rounded-xl p-6 relative shadow-lg">
                        <button
                            onClick={() => setEmailChangeOpen(false)}
                            className="absolute top-3 right-3 text-gray-500 hover:text-black"
                        >
                            <X size={22} />
                        </button>

                        <h3 className="text-xl font-semibold mb-4 text-gray-800">Update Company Details</h3>

                        {/* Company Name */}
                        <div className="mb-3">
                            <label className="text-sm text-gray-600 mb-1 block">Company Name</label>
                            <input
                                type="text"
                                value={companyName}
                                onChange={(e) => setCompanyName(e.target.value)}
                                className="w-full text-sm bg-gray-100 border border-gray-300 rounded-lg px-3 py-2"
                            />
                        </div>

                        {/* From Email */}
                        <div className="mb-3">
                            <label className="text-sm text-gray-600 mb-1 block">From Email</label>
                            <input
                                type="email"
                                value={fromEmail}
                                onChange={(e) => setFromEmail(e.target.value)}
                                className="w-full text-sm bg-gray-100 border border-gray-300 rounded-lg px-3 py-2"
                            />
                        </div>

                        {/* Contact Name */}
                        <div className="mb-3">
                            <label className="text-sm text-gray-600 mb-1 block">Contact Person Name</label>
                            <input
                                type="text"
                                value={contactName}
                                onChange={(e) => setContactName(e.target.value)}
                                className="w-full text-sm bg-gray-100 border border-gray-300 rounded-lg px-3 py-2"
                            />
                        </div>

                        {/* Contact Email */}
                        <div className="mb-3">
                            <label className="text-sm text-gray-600 mb-1 block">Contact Person Email</label>
                            <input
                                type="email"
                                value={contactEmail}
                                onChange={(e) => setContactEmail(e.target.value)}
                                className="w-full text-sm bg-gray-100 border border-gray-300 rounded-lg px-3 py-2"
                            />
                        </div>

                        <button
                            onClick={handleUpdate}
                            disabled={loading}
                            className="w-full bg-teal-500 text-white py-2 mt-2 rounded-lg hover:bg-teal-600"
                        >
                            {loading ? "Updating..." : "Update"}
                        </button>
                    </div>
                </div>
            )}



        </>
    )
};

export default Sidebar;
